import axios from 'axios'
import { Message } from 'element-ui'

const settlementRequest = axios.create({
  baseURL: '/api/admin/settlement',
  timeout: 15000
})

let unauthorizedHandling = false

function handleUnauthorized(message = '登录已过期，请重新登录') {
  localStorage.removeItem('admin_token')
  localStorage.removeItem('admin_username')
  if (!unauthorizedHandling) {
    unauthorizedHandling = true
    Message.error(message)
    window.location.hash = '#/login'
    setTimeout(() => {
      unauthorizedHandling = false
    }, 2000)
  }
}

settlementRequest.interceptors.request.use(
  config => {
    const token = localStorage.getItem('admin_token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => Promise.reject(error)
)

settlementRequest.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        handleUnauthorized(res.message || '登录已过期，请重新登录')
      } else {
        Message.error(res.message || '请求失败')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    const status = error.response && error.response.status
    if (status === 401) {
      const data = error.response.data || {}
      handleUnauthorized(data.message || '登录已过期，请重新登录')
    } else {
      Message.error(error.message || '网络错误')
    }
    return Promise.reject(error)
  }
)

// 获取结算单列表
export function getSettlementList(params) {
  return settlementRequest({
    url: '/list',
    method: 'get',
    params
  })
}

// 生成月度结算单
export function generateSettlement(data) {
  return settlementRequest({
    url: '/generate',
    method: 'post',
    data
  })
}

// 确认结算单
export function confirmSettlement(id) {
  return settlementRequest({
    url: '/' + id + '/confirm',
    method: 'post'
  })
}

// 删除结算单
export function deleteSettlement(id) {
  return settlementRequest({
    url: '/' + id,
    method: 'delete'
  })
}

// 获取结算单详情
export function getSettlementDetail(id) {
  return settlementRequest({
    url: '/' + id,
    method: 'get'
  })
}
